import React from 'react';
import PropTypes from 'prop-types';
import RamblaActionIcon from 'components/RamblaActionIcon/RamblaActionIcon';
import * as Ui from './RamblaActionButtonContent.styles';

const RamblaActionButtonContent = ({ icon, children }) => (
  <Ui.Content>
    <RamblaActionIcon name={icon} />
    {children}
  </Ui.Content>
);

RamblaActionButtonContent.propTypes = {
  icon: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default RamblaActionButtonContent;
